import { intlShape, FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/player-widget/utils/not-for-preview';
import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import openPopup from 'widget/player-widget/utils/open-popup';
import initSocialNetworks from '../social-networks';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './social-button.styl';

import translations from './translations';


@WixConnect(styles)
export default class SocialButton extends React.Component {

  static propTypes = {
    network: React.PropTypes.string.isRequired,
    content: React.PropTypes.shape({
      siteUrl: React.PropTypes.string,
      title: React.PropTypes.string,
      description: React.PropTypes.string,
      thumbnailUrl: React.PropTypes.string,
    }).isRequired,
    rounded: React.PropTypes.bool,
    className: React.PropTypes.string,
    linkClassName: React.PropTypes.string,
    tooltip: React.PropTypes.bool,
    appSettings: React.PropTypes.object,
    openPreviewPrompt: React.PropTypes.func,
    onAfterClicked: React.PropTypes.func,
    intl: intlShape,
  };

  static defaultProps = {
    rounded: false,
    openPreviewPrompt: _.noop,
    onAfterClicked: _.noop,
  };

  state = {
    showPopout: false,
  };

  componentWillMount() {
    const { network, intl: { formatMessage }, appSettings: { hosts } } = this.props;
    this.socialNetwork = initSocialNetworks({
      formatMessage, hosts,
    })[network];
  }

  componentDidMount() {
    const { link, popout, copyLink } = this;
    // We use addEventListener because react`s elements are destroyed before onClick is fired

    if (popout) {
      copyLink.addEventListener('click', this.handleCopyToClipboard);
      popout.addEventListener('click', this.stopPropagation);
      link.addEventListener('click', this.togglePopout);
    } else {
      link.addEventListener('click', this.handleShareIconClick);
    }
  }

  componentWillUnmount() {
    const { link, popout, copyLink } = this;

    if (popout) {
      copyLink.removeEventListener('click', this.handleCopyToClipboard);
      popout.removeEventListener('click', this.stopPropagation);
      link.removeEventListener('click', this.togglePopout);
    } else {
      link.removeEventListener('click', this.handleShareIconClick);
    }
  }

  @autobind
  handleShareIconClick(event) {
    event.preventDefault();
    event.stopPropagation();

    this.openShareWindow();

    const { onAfterClicked, network } = this.props;
    onAfterClicked(network);
  }

  @notForPreview
  openShareWindow() {
    const { content } = this.props;
    const { getShareUrl } = this.socialNetwork;
    openPopup(getShareUrl(content));
  }

  @autobind
  @notForPreview
  togglePopout(event) {
    event.preventDefault();
    event.stopPropagation();

    const { showPopout } = this.state;

    this.setState({
      showPopout: !showPopout,
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  @autobind
  @notForPreview
  handleCopyToClipboard(event) {
    event.preventDefault();

    if (document.queryCommandSupported('copy')) {
      this.input.select();
      document.execCommand('copy');
    }
  }

  saveRef(name) {
    return element => {
      this[name] = element;
    };
  }

  get popoutContent() {
    const { content, network } = this.props;
    const { showPopout } = this.state;
    const { getShareUrl } = this.socialNetwork;

    if (network !== 'link') {
      return null;
    }

    const url = getShareUrl(content);

    const styleNames = classnames('popout', {
      hide: !showPopout,
    });

    return (
      <span styleName={styleNames}
            ref={this.saveRef('popout')}>
        <span styleName="popout-inner">
          <input type="text"
                 value={url}
                 readOnly
                 styleName="copy-url-input"
                 ref={this.saveRef('input')} />
          <a href="#"
             styleName="copy-url-link"
             ref={this.saveRef('copyLink')}>
            <FormattedMessage {...translations.copy} />
          </a>
        </span>
      </span>
    );
  }

  render() {
    const { network, className, rounded, linkClassName, intl: { formatMessage } } = this.props;
    const { name } = this.socialNetwork;

    const styleNames = classnames('social-button', network, {
      rounded,
    });

    return (
      <span styleName="tooltip"
            className={className}>
        <a href="#"
           title={formatMessage(translations[name])}
           styleName={styleNames}
           className={linkClassName}
           ref={this.saveRef('link')}>
          <Icon name={network} />
        </a>

        {this.popoutContent}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/social-share/social-button/social-button.js